import HorizontalCard from '../../../tornado/horizontal-card/horizontalCard.component';
import HorizontalSquare from '../../../tornado/horizontal-square/horizontalSquare.component';

export const CLOSE_SIGNAL = 'close';

export const TEMPLATES = {
  [HorizontalCard.Templates.HorizontalCard]: HorizontalCard,
  [HorizontalSquare.Templates.HorizontalSquare]: HorizontalSquare,
};
